import { Box, FormControlLabel, Pagination, Stack, Switch, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { IRegulation } from '../../contracts/amendment.contract';
import { ICalendarRiskGroup } from '../../contracts/calendar-risk-group.contract';
import { IVessel } from '../../contracts/vessel.contract';
import RegulationCardsItem from '../regulation/regulation-cards-item.component';

type RegulationRisk = {
    regulation: IRegulation;
    vessels: IVessel[];
    riskType: 'High' | 'Medium' | 'Low';
};

const CalendarRiskListItem = ({ risks }: { risks: ICalendarRiskGroup }) => {
    // State for pagination
    const rowsPerPage = 10;
    const [page, setPage] = useState<number>(0);
    const [pageData, setPageData] = useState<RegulationRisk[]>([]);
    const [expandAll, setExpandAll] = useState<boolean>(false);

    const [regulationRisks, setRegulationRisks] = useState<RegulationRisk[] | undefined>();

    useEffect(() => {
        if (!risks) return;

        let tempRegRisks: RegulationRisk[] = [];

        risks.HighRisks.forEach((risk) => tempRegRisks.push({ regulation: risk.Regulation, vessels: risk.Vessels, riskType: 'High' }));
        risks.MediumRisks.forEach((risk) => tempRegRisks.push({ regulation: risk.Regulation, vessels: risk.Vessels, riskType: 'Medium' }));
        risks.LowRisks.forEach((risk) => tempRegRisks.push({ regulation: risk.Regulation, vessels: risk.Vessels, riskType: 'Low' }));

        setRegulationRisks([...tempRegRisks]);
    }, [risks]);

    useEffect(() => {
        if (!regulationRisks) return;

        // Calculate the start and end indices based on the current page
        const startIndex = page * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;

        // Update the page data based on the calculated indices
        const newPageData = regulationRisks.slice(startIndex, endIndex) || [];
        setPageData([...newPageData]);
    }, [regulationRisks, page]);

    const handlePageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
        setPage(newPage - 1); // Adjust for 0-based index
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setExpandAll(event.target.checked);
    };

    return (
        <>
            {pageData && pageData.length === 0 ? (
                <Typography variant="h6">No Regulations Found.</Typography>
            ) : (
                <>
                    {/* Top Pagination Controls */}
                    <Stack direction="row" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                        <div></div>
                        <Box flexGrow={1} display="flex" justifyContent="center">
                            <Pagination
                                color="primary"
                                count={Math.ceil((regulationRisks?.length || 0) / rowsPerPage)}
                                page={page + 1}
                                onChange={handlePageChange}
                                variant="outlined"
                                shape="rounded"
                            />
                        </Box>
                        <FormControlLabel control={<Switch checked={expandAll} onChange={handleChange} name="expandAll" />} label="Expand All" />
                    </Stack>

                    {pageData.map((risk, index) => {
                        return (
                            <RegulationCardsItem
                                key={`${risk.regulation.RegulationDocName}-${index}`}
                                regulation={risk.regulation}
                                expandAll={expandAll}
                                vessels={risk.vessels}
                                riskType={risk.riskType}
                            />
                        );
                    })}

                    {/* Bottom Pagination Controls */}
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'center'}>
                        <Pagination color="primary" count={Math.ceil((regulationRisks?.length || 0) / rowsPerPage)} page={page + 1} onChange={handlePageChange} variant="outlined" shape="rounded" />
                    </Stack>
                </>
            )}
        </>
    );
};

export default CalendarRiskListItem;
